var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlovoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FFC600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1967 7.5C12.6047 7.5 10.5 9.60469 10.5 12.1967C10.5 13.1816 10.8007 14.1355 11.3813 14.9338L11.5057 15.11L13.9525 18.5729C13.9525 18.5729 14.2532 19.0706 14.9064 19.0706H15.4973C16.1401 19.0706 16.4512 18.5729 16.4512 18.5729L18.898 15.11L19.0224 14.9338C19.603 14.1251 19.9141 13.1816 19.9141 12.1967C19.8933 9.59432 17.7886 7.5 15.1967 7.5ZM17.1251 13.586L17.0007 13.7622L15.207 16.3127L13.3926 13.7622L13.2682 13.5756C12.9779 13.1609 12.812 12.684 12.812 12.1863C12.812 10.8696 13.8696 9.81204 15.1863 9.80168C15.1863 9.80168 15.1863 9.80168 15.1967 9.80168C16.5134 9.80168 17.5709 10.8592 17.5813 12.1759C17.5813 12.1759 17.5813 12.1759 17.5813 12.1863C17.5709 12.684 17.4154 13.1816 17.1251 13.586ZM13.8799 21.1753C13.8799 20.4703 14.4398 19.8793 15.1863 19.8793C15.9432 19.8793 16.4927 20.4495 16.4927 21.1545V21.1649C16.4927 21.8596 15.9328 22.4402 15.1759 22.4402C14.4191 22.4402 13.8799 21.8699 13.8799 21.1753Z",
    fill: "#00A082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlovoLogo);
export default __webpack_public_path__ + "static/media/glovo-logo.ca8d32e4287b81feedd1747b75a396aa.svg";
export { ForwardRef as ReactComponent };